import * as types from 'store/moderator/moderatorTypes'
import { call, put, takeLatest } from 'redux-saga/effects'
import API from 'store/moderator/moderatorApis.js'
import { isPMOrAdmin } from 'shared/helpers/user'

function* watchUpdateModeratorDetails({payload : payload}) {
    try {
      const response = yield call(API.updateModeratorDetails ,payload)
     if ( response.status === 200 ) {
        yield put({type:'UPDATE_MODERATOR_DETAILS_SUCCEEDED', payload: payload});
        yield put({type: 'CLOSE_EDIT_INTERVIEW_OR_MODERATOR_BUFFER_MODAL'});
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'Moderator Time Buffer successfully updated.', className: 'copy-screeners-snackbar'}})
        yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar'}})
        if(isPMOrAdmin()) yield put({ type: 'FETCH_MODERATOR_AVAILABILITY_REQUESTED', payload :{moderatorId: payload.moderatorId, clientId:payload.clientId, isModeratorManagement: true } })
      } else if (response.status === 401) {
          yield put({type:'UNAUTHORIZED'})
      } else {
          yield put({type: 'UPDATE_MODERATOR_DETAILS_FAILED'})
          yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
          yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar'}})
      }
     } catch (err) {
         console.log("Update moderator details request failed: ",err);
         yield put({type: 'UPDATE_MODERATOR_DETAILS_FAILED', err})
         yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again', className: 'copy-screeners-snackbar'}})
         yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar'}})
       }
  }

  export default function* watchModerator () {
    yield takeLatest(types.UPDATE_MODERATOR_DETAILS_REQUESTED, watchUpdateModeratorDetails)
  }
  